import { useEffect, useRef, useState } from "react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import APIS from "../constant/Endpoint";
import useGetHook from "../hooks/useGetHook";
import Emails from "./Emails";
import MailDetail from "./MailDetail/MailDetail";
import { classNames } from "../utils/classNames";
import { getEmailFolderId } from "../layouts/DashboardLayout";
import Settings from "./settings/Settings";
import SwitchAccount from "./switchAccount/SwitchAccount";

const Inbox = () => {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams({
    limit: "10",
    page: "0",
    search: "",
  });
  const [refreshFlag, setRefreshFlag] = useState("false");

  const foldersId: any = getEmailFolderId();

  const limit = parseInt(searchParams.get("limit") ?? "10");
  const page = parseInt(searchParams.get("page") ?? "0");
  const type = params?.id || searchParams.get("type") || "a";
  const search = searchParams.get("search") || "";

  const offset = limit * page;

  const [selectedEmail, setSelectedEmail] = React.useState<string | null>(null);
  const { data: mails, isLoading } = useGetHook({
    queryKey: ["inbox", type, limit, page, search, refreshFlag],
    url: APIS.EMAIL,
    params: {
      ...params,
      limit,
      offset,
      search,
      type,
    },
    interval: 5000,
  });

  const total = mails?.count ?? 0;
  const totalPages = Math.max(Math.ceil(total / limit), 1);
  const lastPage = Math.max(totalPages - 1, 0);

  const setPage = (p: number) => {
    const safePage = Math.max(0, Math.min(p, lastPage));
    searchParams.set("page", String(safePage));
    setSearchParams(searchParams);
  };

  const handleNext = () => setPage(page + 1);
  const handlePrevious = () => setPage(page - 1);
  const handleFirst = () => setPage(0);
  const handleLast = () => setPage(lastPage);

  const handleLimitChange = (newLimit: number) => {
    searchParams.set("limit", String(newLimit));
    searchParams.set("page", "0");
    setSearchParams(searchParams);
  };

  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const buttonRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!isOpenPopup) return;

      const modal = modalRef.current;
      const button = buttonRef.current;

      if (
        modal &&
        !modal.contains(e.target as Node) &&
        button &&
        !button.contains(e.target as Node)
      ) {
        setIsOpenPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenPopup]);

  return (
    <div className={tw`relative pb-4`}>
      {type === foldersId?.Settings ? (
        <Settings />
      ) : type === foldersId?.Switch ? (<SwitchAccount/>) : (
        <div
          className={classNames(
            tw``,
            selectedEmail && tw`grid grid-cols-2 gap-4`
          )}
        >
          <div>
            <Emails
              mails={mails}
              setSelectedEmail={setSelectedEmail} 
              isLoading={isLoading}
            />

            {mails?.results?.length > 0 && !isLoading && (
              <div
                className={tw`flex bg-white py-2 mt-2 w-full justify-center items-center gap-4`}
              >
                <button
                  className={tw`border hidden md:block rounded p-1 disabled:opacity-40`}
                  onClick={handleFirst}
                  disabled={page === 0}
                >
                  {"<<"}
                </button>

                <button
                  className={tw`border rounded p-1 disabled:opacity-40`}
                  onClick={handlePrevious}
                  disabled={page === 0}
                >
                  {"<"}
                </button>

                <button
                  className={tw`border rounded p-1 disabled:opacity-40`}
                  onClick={handleNext}
                  disabled={page >= lastPage}
                >
                  {">"}
                </button>

                <button
                  className={tw`border hidden md:block rounded p-1 disabled:opacity-40`}
                  onClick={handleLast}
                  disabled={page >= lastPage}
                >
                  {">>"}
                </button>

                <span className={tw`flex items-center gap-1`}>
                  <div>Page</div>
                  <strong>
                    {page + 1} of {totalPages}
                  </strong>
                </span>

                <select
                  value={limit}
                  onChange={(e) => handleLimitChange(Number(e.target.value))}
                  className={tw`border rounded p-1`}
                >
                  {[10, 50, 100, 200, 500].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>

                <p className={tw`mt-1`}>All: {total}</p>
              </div>
            )}
          </div>

          <div className={tw`w-full`}>
            {selectedEmail && (
              <MailDetail
                selectedEmailID={selectedEmail}
                onClose={() => {
                  setRefreshFlag((prev) =>
                    prev === "false" ? "true" : "false"
                  );
                  setSelectedEmail(null);
                  searchParams.delete("mailId");
                  setSearchParams(searchParams);
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Inbox;
